import { render, staticRenderFns } from "./Violence.vue?vue&type=template&id=7f8f1302"
import script from "./Violence.vue?vue&type=script&lang=js"
export * from "./Violence.vue?vue&type=script&lang=js"
import style0 from "./Violence.vue?vue&type=style&index=0&id=7f8f1302&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports